import React from "react";
import { Icons, IconButton, Tooltip } from "@curves/ui-base";

const AddInvalidActionBar = props => {
	const { getResult: getResultProps = () => {}, dialogRef, refresh: refreshProps } = props;

	const handleClick = () => {
		const targetData = getResultProps();
		if (dialogRef && dialogRef.current && targetData.list.length !== 0) dialogRef.current.openNonMemberAddInvalid(targetData, refreshProps);
	};

	return (
		<Tooltip title={"新增至無效"}>
			<IconButton onClick={handleClick}>
				<Icons.UserSlash />
			</IconButton>
		</Tooltip>
	);
};

export default AddInvalidActionBar;
